<div class="inner {{ theme ? theme : 'default' }}-theme">
	<div class="option-bar">
		<div class="option-bar-item" *ngIf="useMacroSuggestions">
            <bb-macro-suggestions [theme]="isDarkMode ? 'dark' : 'light-v2'" (selected)="onSuggestionSelected($event)"></bb-macro-suggestions>
        </div>
		<div class="option-bar-item">
			<button class="mat-elevation-z" type="button" mat-mini-fab (click)="toggleTheme()"
				[title]="'TOGGLE_DARK_MODE' | translate">
				<i *ngIf="!isDarkMode" class="fas fa-moon"></i>
				<i *ngIf="isDarkMode" class="fas fa-sun"></i>
			</button>
		</div>
		<div class="option-bar-item" *ngIf="!inModal && !hideFullscreen">
			<button class="mat-elevation-z" type="button" mat-mini-fab (click)="toggleFullScreen()"
				[title]="'TOGGLE_FULLSCREEN' | translate">
				<i *ngIf="isFullscreen" class="fas fa-down-left-and-up-right-to-center"></i>
				<i *ngIf="!isFullscreen" class="fas fa-up-right-and-down-left-from-center"></i>
			</button>
		</div>
		<div class="option-bar-item" *ngIf="inModal">
			<button class="mat-elevation-z" type="button" mat-mini-fab (click)="closeModal()" [title]="'CLOSE_MODAL' | translate">
				<i class="fas fa-times"></i>
			</button>
		</div>
	</div>
	<div class="editor-container" #editorContainer></div>
</div>
